import { render } from "./CertificateFromDocument.vue?vue&type=template&id=10e7df3a&scoped=true"
import script from "./CertificateFromDocument.vue?vue&type=script&lang=js"
export * from "./CertificateFromDocument.vue?vue&type=script&lang=js"

import "./CertificateFromDocument.vue?vue&type=style&index=0&id=10e7df3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e7df3a"]])

export default __exports__